import React from 'react'
import Preheader from './Preheader'
import Table from './Table'
import Parters from './Parters'
import { Helmet } from 'react-helmet'
import Footer from './Footer'
export default function Standing() {
  return (
  <>


<Helmet>
        <title>
 
        New Delhi Tigers DPLT20 League Results & Scores | New Delhi Tigers Match Outcomes & Points Table

        </title>
        <meta
          name="title"
          content="New Delhi Tigers Kabaddi League Results & Scores | New Delhi Tigers Match Outcomes & Points Table
"
        />
        <meta
          name="keywords"
          content=" 
 New Delhi Tigers players
New Delhi Tigers players name
players of New Delhi Tigers
New Delhi Tigers Allrounders
New Delhi Tigers raiders
New Delhi Tigers defenders
"
        />

        <meta
          name="description"
          content="New Delhi Tigers in the Delhi Premier League (DPLT20) and stay updated on Cricket tournaments in Delhi. Check the latest points table and see how New Delhi Tigers ranks against the competition. Discover match schedules, results, and league standings.
"
        />

        <link rel="canonical" href="https://newdelhitigers./standings" />
      </Helmet>


  <Preheader/>
   <div class="container-fluid p-0">
        <div class="breadcrumb-bg">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                <div className="newheading1">
  <h5>Standings</h5>
  <div className="line"></div>
</div>          
                </ol>
            </nav>
        </div>
        </div>

        <Table/>
        <Parters/>
        <Footer/>
  </>
  )
}
